import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import axios from 'axios';
import ConfigManager from '../managers/ConfigManager';

var SettingsService = /*#__PURE__*/function () {
  function SettingsService() {
    _classCallCheck(this, SettingsService);

    this.adminSettingsUrl = ConfigManager.appConfig.settings.adminSettingsUrl;
  }

  _createClass(SettingsService, [{
    key: "retrieveAdminSettings",
    value: function () {
      var _retrieveAdminSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios.get(this.adminSettingsUrl);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function retrieveAdminSettings() {
        return _retrieveAdminSettings.apply(this, arguments);
      }

      return retrieveAdminSettings;
    }()
  }, {
    key: "saveAdminSettings",
    value: function () {
      var _saveAdminSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(settings) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return axios.post(this.adminSettingsUrl, settings);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function saveAdminSettings(_x) {
        return _saveAdminSettings.apply(this, arguments);
      }

      return saveAdminSettings;
    }()
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return SettingsService;
}();

export { SettingsService as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SettingsService, "SettingsService", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/services/SettingsService.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();